/* Local email preparation only: no storage, network request or submission. */
(function () {
  'use strict';
  const SAV = 'savmiragedemusc@gmail.com';
  const clean = (value, limit = 800) => String(value || '').replace(/\r/g, '').trim().slice(0, limit);

  function frenchDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return '';
    const date = new Date(value + 'T12:00:00Z');
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return '';
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
  }

  function buildWithdrawalMessage(values = {}) {
    const lines = [
      'À l’attention de Mirage de Musc,',
      '',
      'Je vous notifie par la présente ma rétractation du contrat portant sur la vente du ou des biens ci-dessous :',
      '',
      clean(values.products) || '[Produit(s) et quantité(s) à compléter]',
      '',
      'Numéro de commande : ' + (clean(values.orderNumber, 80) || '[à compléter si disponible]'),
      'Commandé le : ' + (frenchDate(values.orderedDate) || '[à compléter si connu]'),
      'Reçu le : ' + (frenchDate(values.receivedDate) || '[à compléter si connu]'),
      'Nom : ' + (clean(values.customerName, 120) || '[à compléter]'),
      '',
      'Merci de me communiquer les instructions pour le retour.',
      '',
      'Cordialement,'
    ];
    if (clean(values.customerName, 120)) lines.push(clean(values.customerName, 120));
    return lines.join('\n');
  }

  function makeMailto(body, orderNumber) {
    const number = clean(orderNumber, 80).replace(/[\n\t]+/g, ' ');
    const subject = 'Demande de rétractation' + (number ? ' — commande ' + number : '');
    return 'mailto:' + SAV + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(clean(body, 2400));
  }

  function init() {
    const form = document.querySelector('[data-withdrawal-form]');
    if (!form || form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    const prepare = form.querySelector('[data-prepare-withdrawal]');
    const draft = form.querySelector('#withdrawal-draft');
    const message = form.querySelector('[data-withdrawal-message]');
    const email = form.querySelector('[data-withdrawal-mailto]');
    const status = form.querySelector('[data-withdrawal-status]');
    if (!prepare || !draft || !message || !email || !status) return;
    const field = name => form.querySelector('[name="' + name + '"]');
    let preparedOrderNumber = '';
    let dirty = false;

    function updateMailto() {
      email.href = makeMailto(message.value, preparedOrderNumber);
    }

    function prepareDraft() {
      const values = {};
      for (const name of ['customerName', 'orderNumber', 'orderedDate', 'receivedDate', 'products']) {
        const input = field(name);
        if (input && !input.reportValidity()) return;
        values[name] = input ? input.value : '';
      }
      message.value = buildWithdrawalMessage(values);
      preparedOrderNumber = values.orderNumber;
      updateMailto();
      draft.hidden = false;
      dirty = false;
      status.textContent = 'Votre message est préparé ci-dessous. Relisez-le avant de l’envoyer depuis votre messagerie.';
      prepare.innerHTML = 'Actualiser mon email';
    }

    prepare.addEventListener('click', prepareDraft);
    message.addEventListener('input', updateMailto);
    form.addEventListener('input', event => {
      if (!event.target.matches('[name]') || draft.hidden || dirty) return;
      dirty = true;
      status.textContent = 'Les informations ont changé. Actualisez votre email pour les reprendre dans le message.';
    });
    // Enter on a short field prepares a draft without invoking the shared
    // preview's global submit handler. Textareas retain their normal newlines.
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input') && !event.isComposing) {
        event.preventDefault();
        prepareDraft();
      }
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { frenchDate, buildWithdrawalMessage, makeMailto };
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  }
}());
